// src/Reports.js
import React, { useState, useEffect } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import ReportsGrid from '../Components/ReportsGrid.js';
import '../CSS/Reports.css';
import '../CSS/PowerBI.css';
import useIsMobile from '../Components/UseIsMobile.js';

function Reports() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSector, setSelectedSector] = useState('');
  const [groupResponsible, setGroupResponsible] = useState('');
  const [targetedEntity, setTargetedEntity] = useState('');
  const [selectedDropdownFilter, setSelectedDropdownFilter] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedIndustryFilter, setSelectedIndustryFilter] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [cityFilter, setCityFilter] = useState('');
  const [stateFilter, setStateFilter] = useState('');
  const [countryFilter, setCountryFilter] = useState('');

  // ✅ NEW: Preliminary Intelligence Note filter
  // values: 'all' | 'hide' | 'only'
  const [prio3Filter, setPrio3Filter] = useState('all');

  const [access_token, setAccessToken] = useState('');
  const isMobile = useIsMobile();

  useEffect(() => {
    fetch('/api/hello')
      .then((response) => response.json())
      .then((data) => setAccessToken(data.accessToken))
      .catch((error) => console.error('Error fetching reports data:', error));
  }, []);

  const clearFilters = () => {
    setSearchTerm('');
    setSelectedSector('');
    setGroupResponsible('');
    setTargetedEntity('');
    setSelectedDropdownFilter('');
    setStartDate('');
    setEndDate('');
    setSelectedIndustryFilter('');
    setSelectedRegion('');
    setCityFilter('');
    setStateFilter('');
    setCountryFilter('');
    setPrio3Filter('all'); // ✅ reset new filter
  };

  return (
    <>
      {/* ===================== DESKTOP ===================== */}
      {!isMobile && (
        <div className="reports-page">

          {/* --------------------- SIDEBAR --------------------- */}
          <aside className="reports-sidebar">
            <h2 className="filters-title">Filters</h2>

            {/* Sector */}
            <div className="filter-group">
              <label>Sector</label>
              <select
                value={selectedSector}
                onChange={(e) => setSelectedSector(e.target.value)}
              >
                <option value="">All Sectors</option>
                <option value="Animal Rights">Animal Rights</option>
                <option value="Energy Sector">Energy Sector</option>
                <option value="Pharmaceuticals">Pharmaceuticals</option>
              </select>
            </div>

            {/* Region */}
            <div className="filter-group">
              <label>Region</label>
              <select
                value={selectedRegion}
                onChange={(e) => setSelectedRegion(e.target.value)}
              >
                <option value="">All Regions</option>
                <option value="North America">North America</option>
                <option value="Latin America">Latin America</option>
                <option value="Western Europe">Western Europe</option>
                <option value="Eastern Europe">Eastern Europe</option>
                <option value="Middle East">Middle East</option>
                <option value="Asia">Asia</option>
                <option value="Africa">Africa</option>
                <option value="Oceania">Oceania</option>
              </select>
            </div>

            {/* Search by title */}
            <div className="filter-group">
              <label>Search by Title</label>
              <input
                type="text"
                value={searchTerm}
                placeholder="Search by Title"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* Group Responsible */}
            <div className="filter-group">
              <label>Group Responsible</label>
              <input
                type="text"
                value={groupResponsible}
                placeholder="Search by group"
                onChange={(e) => setGroupResponsible(e.target.value)}
              />
            </div>

            {/* Targeted Entity */}
            <div className="filter-group">
              <label>Targeted Entity</label>
              <input
                type="text"
                value={targetedEntity}
                placeholder="Search by targeted entity"
                onChange={(e) => setTargetedEntity(e.target.value)}
              />
            </div>

            {/* Report type */}
            <div className="filter-group">
              <label>Type of Report</label>
              <select
                value={selectedDropdownFilter}
                onChange={(e) => setSelectedDropdownFilter(e.target.value)}
              >
                <option value="">All Types</option>
                <option value="protest after-action">Protest After-Action</option>
                <option value="direct action">Direct Action</option>
                <option value="general intel">General Intel</option>
                <option value="infiltration">Infiltration</option>
              </select>
            </div>

            {/* Industry */}
            <div className="filter-group">
              <label>Targeted Industry</label>
              <select
                value={selectedIndustryFilter}
                onChange={(e) => setSelectedIndustryFilter(e.target.value)}
              >
                <option value="">All Industries</option>
                <option value="Fur and Leather">Fur and Leather</option>
                <option value="Pet Industry">Pet Industry</option>
                <option value="Hunting">Hunting</option>
                <option value="Academic">Academic</option>
                <option value="Government">Government</option>
                <option value="Nuclear">Nuclear</option>
                <option value="Research – Academic">Research - Academic</option>
                <option value="Research – Breeder">Research - Breeder</option>
                <option value="Research – CRO">Research - CRO</option>
                <option value="Research – Cosmetics">Research - Cosmetics</option>
                <option value="Research – General">Research - General</option>
                <option value="Research – Government">Research - Government</option>
                <option value="Research – Pharmaceuticals">Research - Pharmaceuticals</option>
                <option value="Research – Tertiary Target">Research - Tertiary Target</option>
                <option value="Research – Transportation">Research - Transportation</option>
                <option value="Research – Other">Research - Other</option>
                <option value="Agriculture – Farms">Agriculture - Farms</option>
                <option value="Agriculture – Food Service">Agriculture - Food Service</option>
                <option value="Agriculture – General">Agriculture - General</option>
                <option value="Agriculture – Government">Agriculture - Government</option>
                <option value="Agriculture – Processing">Agriculture - Processing</option>
                <option value="Agriculture – Transportation">Agriculture - Transportation</option>
                <option value="Entertainment – Government">Entertainment - Government</option>
                <option value="Entertainment – Sports">Entertainment - Sports</option>
                <option value="Entertainment – Zoo/Park">Entertainment - Zoo/Park</option>
                <option value="Coal">Coal</option>
                <option value="Fossil Fuels">Fossil Fuels</option>
                <option value="Renewables">Renewables</option>
                <option value="Logging">Logging</option>
                <option value="Academic">Academic</option>
                <option value="Financing">Financing</option>
                <option value="Anti-Vaccine">Anti-Vaccine</option>
                <option value="GMO">GMO</option>
                <option value="Access to Medicine">Access to Medicine</option>
                <option value="Other">Other</option>
              </select>
            </div>

            {/* Dates */}
            <div className="filter-group">
              <label>Start Date</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>

            <div className="filter-group">
              <label>End Date</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>

            {/* Location */}
            <div className="filter-group">
              <label>City</label>
              <input
                type="text"
                value={cityFilter}
                onChange={(e) => setCityFilter(e.target.value)}
              />
            </div>

            <div className="filter-group">
              <label>State / Province</label>
              <input
                type="text"
                value={stateFilter}
                onChange={(e) => setStateFilter(e.target.value)}
              />
            </div>

            <div className="filter-group">
              <label>Country</label>
              <input
                type="text"
                value={countryFilter}
                onChange={(e) => setCountryFilter(e.target.value)}
              />
            </div>

            {/* ✅ NEW: Preliminary Intelligence Note */}
            <div className="filter-group">
              <label>Preliminary Intelligence Note</label>
              <select
                value={prio3Filter}
                onChange={(e) => setPrio3Filter(e.target.value)}
              >
                <option value="all">Show All Reports</option>
                <option value="hide">Hide Preliminary Notes</option>
                <option value="only">Only Preliminary Notes</option>
              </select>
            </div>

            <button className="clear-button full-width" onClick={clearFilters}>
              Clear Filters
            </button>
          </aside>

          {/* --------------------- MAIN CONTENT --------------------- */}
          <main className="reports-main">
            <h1 className="reports-title">Reports Index</h1>

            <div className="stats-ticker">
              <style>{`iframe { border: none; }`}</style>
              {access_token && (
                <PowerBIEmbed
                  embedConfig={{
                    type: 'report',
                    id: '1a7fd4bc-959b-4fe5-b2e8-36d6b56150b1',
                    embedUrl:
                      'https://app.powerbi.com/reportEmbed?reportId=1a7fd4bc-959b-4fe5-b2e8-36d6b56150b1&groupId=8462ee1f-e8db-4f03-bba9-021eabab566f',
                    accessToken: access_token,
                    tokenType: models.TokenType.Aad,
                    pageName: "ReportSectionf6aa38c61856112b0cc0",
                    settings: {
                      panes: { filters: { visible: false } },
                      navContentPaneEnabled: false,
                      background: models.BackgroundType.Transparent,
                    },
                  }}
                />
              )}
            </div>

            <ReportsGrid
              searchTerm={searchTerm}
              selectedSector={selectedSector}
              groupResponsible={groupResponsible}
              targetedEntity={targetedEntity}
              selectedDropdownFilter={selectedDropdownFilter}
              startDate={startDate}
              endDate={endDate}
              selectedIndustryFilter={selectedIndustryFilter}
              selectedRegion={selectedRegion}
              cityFilter={cityFilter}
              stateFilter={stateFilter}
              countryFilter={countryFilter}
              prio3Filter={prio3Filter} // ✅ passed through for later logic
            />
          </main>
        </div>
      )}

      {/* ===================== MOBILE ===================== */}
      {isMobile && (
        <ReportsGrid
          searchTerm={searchTerm}
          selectedSector={selectedSector}
          groupResponsible={groupResponsible}
          targetedEntity={targetedEntity}
          selectedDropdownFilter={selectedDropdownFilter}
          startDate={startDate}
          endDate={endDate}
          selectedIndustryFilter={selectedIndustryFilter}
          selectedRegion={selectedRegion}
          cityFilter={cityFilter}
          stateFilter={stateFilter}
          countryFilter={countryFilter}
          prio3Filter={prio3Filter} // still passed for consistency
        />
      )}
    </>
  );
}

export default Reports;
